module.exports = __webpack_public_path__ + "img/stvrt-prvedomy.b4a3ce30.jpg";